<template>
  <v-select
    v-model="value"
    multiple
    :options="options"
    :placeholder="locales[lang].categories.label"
    :create-option="(tag) => ({ label: tag, value: tag })"
    @input="edited"
  >
    <template #open-indicator="{ attributes }">
      <span v-bind="attributes">
        <i class="text-gray-400 fal fa-chevron-down" />
      </span>
    </template>
  </v-select>
</template>

<script>
import bus from "../js/bus.js";

export default {
  props: ["lang", "locales"],
  data() {
    return {
      value: [],
    };
  },
  computed: {
    options() {
      let result = [];
      if (this.lang) {
        result = [
          {
            label: this.locales[this.lang].categories.house,
            value: "house",
          },
          {
            label: this.locales[this.lang].categories.apartment,
            value: "apartment",
          },
          {
            label: this.locales[this.lang].categories.land,
            value: "land",
          },
          {
            label: this.locales[this.lang].categories.commercial,
            value: "commercial",
          },
          {
            label: this.locales[this.lang].categories.office,
            value: "office",
          },
          {
            label: this.locales[this.lang].categories.parking,
            value: "parking",
          },
        ];
      }
      return result;
    },
  },
  mounted() {
    bus.$on("updateData", (item) => {
      if (item.id === "categories") {
        this.value = [];
        item.data.forEach((value) => {
          this.value.push({
            label: this.locales[this.lang].categories[value],
            value,
          });
        });
      }
    });
  },
  methods: {
    edited() {
      bus.$emit("setData", {
        id: "categories",
        data: this.value,
      });
    },
  },
};
</script>

